import { useState, useCallback, useEffect } from "react";
import * as serviceWorkerRegistration from "../serviceWorkerRegistration";
import { resetLocalStorageTranslation } from "utilities/storageUtilities";

export const useServiceWorker = () => {
    const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
    const [showReload, setShowReload] = useState<boolean>(false);
    // Called when a service worker updates. This function is a callback
    // to the actual service worker registration onUpdate.
    const onSWUpdate = useCallback((registration: ServiceWorkerRegistration) => {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    }, []);

    // Called when there is a waiting service worker. This function is a callback
    // to the actual service worker registration onWaiting.
    const onSWWaiting = useCallback((registration: ServiceWorkerRegistration) => {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    }, []);

    // Simply put, this tells the service worker to skip the waiting phase and then reloads the page
    const reloadPage = useCallback(() => {
        waitingWorker?.postMessage({ type: "SKIP_WAITING" });
        setShowReload(false);
        resetLocalStorageTranslation();
        // Force a hard reload
        setTimeout(() => {
            window.location.replace(window.location.href);
        }, 100);
    }, [waitingWorker]);

    // register the service worker
    useEffect(() => {
        // If you want your app to work offline and load faster, you can change
        // unregister() to register() below. Note this comes with some pitfalls.
        // Learn more about service workers: https://cra.link/PWA
        serviceWorkerRegistration.register({
            onUpdate: onSWUpdate,
            onWaiting: onSWWaiting,
            onSuccess: (registration: ServiceWorkerRegistration) => {
                console.log("Service Worker registration successful with scope: ", registration.scope);
            },
        });
    }, [onSWUpdate, onSWWaiting]);
    return { showReload, waitingWorker, reloadPage };
};
